import {Deal} from "@irati/types"
import DealSavingsType from "@irati/deals/types/enums/DealSavingsType"

const isBoostedPerk = (deal: Deal) => {
  const {
    savings: {userSavings}
  } = deal
  const isCurrencyOrPercentageSaving = userSavings.type === DealSavingsType.CURRENCY || userSavings.type === DealSavingsType.PERCENTAGE
  return isCurrencyOrPercentageSaving && !!deal?.savings?.userSavings && !!deal?.savings?.boostedSavings?.oldSavings
}

export default isBoostedPerk
